import React, { useContext, useState } from 'react'
import { GVarState } from '../../StoreState/Gstate';
import { useSearchParams } from 'react-router-dom';
import ConfigReact, { BASE_URL } from '../../ConfigReact';

function TiltViewAdmin() {
  const g = useContext(GVarState);

  const [searchParams] = useSearchParams();
  const [saveFor, setSaveFor] = useState('pc');

  return (
    <div className="absolute top-[50%] right-4 z-50">
      <ConfigReact />
      <div className="bg-white/90 shadow-xl px-5 py-4 rounded-xl border border-gray-300 w-[250px]">

        <h3 className="text-lg font-semibold text-gray-800 mb-3">
          🎯 Save Camera View
        </h3>

        {/* ✅ Radio Buttons */}
        <div className="flex items-center gap-4 mb-4">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              value="pc"
              checked={saveFor === "pc"}
              onChange={() => setSaveFor("pc")}
              className="w-4 h-4 accent-blue-600"
            />
            <span className="text-sm text-gray-700">PC</span>
          </label>

          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              value="mobile"
              checked={saveFor === "mobile"}
              onChange={() => setSaveFor("mobile")}
              className="w-4 h-4 accent-blue-600"
            />
            <span className="text-sm text-gray-700">Mobile</span>
          </label>
        </div>

        {/* ✅ Save Button */}
        <button
          onClick={() => {
            const camera = g.cameraRef.current;
            const controls = g.controllerRef.current;
            const floor = g.CurrentFloor;

            if (!camera || !controls) return;

            const stored = JSON.parse(localStorage.getItem("floorCameraData") || "{}");
            if (!stored[floor]) stored[floor] = {};

            stored[floor][saveFor] = {
              camera: {
                x: camera.position.x,
                y: camera.position.y,
                z: camera.position.z,
                zoom: camera.zoom,
              },
              controls: {
                x: controls.target.x,
                y: controls.target.y,
                z: controls.target.z,
              },
            };

            localStorage.setItem("floorCameraData", JSON.stringify(stored));


            const mallId = searchParams.get("m")

            if (mallId) {
              const mallData = localStorage.getItem("mallid" + mallId)
              if (mallData) {
                let jsonMallData = JSON.parse(mallData)
                jsonMallData.data.more = jsonMallData.data.more || {};
                jsonMallData.data.more.viewState = stored
                // api calling
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                var raw = JSON.stringify({
                  "name": mallId,
                  "username": "anu",
                  "password": "anu is best",
                  "file": jsonMallData.data
                });

                var requestOptions = {
                  method: 'POST',
                  headers: myHeaders,
                  body: raw,
                  redirect: 'follow'
                };

                fetch(BASE_URL + "/userdata", requestOptions)
                  .then(response => response.json())
                  .then(result => {
                    alert(result.msg)
                localStorage.setItem("mallid" + mallId, JSON.stringify(jsonMallData))

                  })
                  .catch(error => console.log('error', error));

              }

            }

          }}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-lg transition-all duration-200"
        >
          💾 Save View
        </button>
      </div>
    </div>
  );
}


export default TiltViewAdmin